import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import get from 'lodash/get';

import Loading from 'components/Loading/Loading';
import Footer from '../Footer';
import LevelSelect from './LevelSelect';
import LearningReasonSelect from './LearningReasonSelect';
import AdditionalInfo from './AdditionalInfo';
import OtherReason from './OtherReason';

class LanguageProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      learningReasons: [],
      learningReasonFetching: true,
      learningReasonFetchError: null,
      submitting: false,
      submitError: null,
    }
  }

  componentDidMount() {
    this.getLearningReasons();
  }

  validateForm = () => {
    const { languageProfile } = this.props;
    if (languageProfile.level === "") {
      return 'Please select a language level';
    }

    if (languageProfile.selectedReasonId === "") {
      return 'Please select your reason for learning';
    }

    const selectedReason = this.state.learningReasons.find(item => item.id === parseInt(languageProfile.selectedReasonId));

    if (selectedReason && selectedReason.description === "Other" && languageProfile.otherReason.trim() === "") {
      return 'Please tell us the other reason why you are learning.';
    }

    if (languageProfile.additionalInfo !== '' && languageProfile.additionalInfo.trim().length < 10) {
      return 'Your response is too short';
    }
    return null;
  }

  getLearningReasons = async () => {
    try {
      const response = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_URL}/learningReasons`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${this.props.user.token}`
            }
          }
        );
      this.setState({ learningReasons: response.data.data, learningReasonFetching: false });
    } catch (error) {
      this.setState({
        learningReasonFetchError: get(error, 'response.data.message', 'Something went wrong, please try again.'),
        learningReasonFetching: false
      });
    }
  }

  handleChange = (event) => {
    this.props.onChange(event.target.name, event.target.value);
  }

  handleNext = (event) => {
    event.preventDefault();
    const validationError = this.validateForm();
    if (validationError) {
      this.setState({ submitError: validationError });
      return;
    }
    this.setState({ submitting: true, submitError: null });
    this.props.onNext((error) => {
      this.setState({ submitting: false, submitError: error });
    });
  }

  renderOtherReasonInput = () => {
    const { languageProfile } = this.props;
    const { learningReasons } = this.state;

    const selectedReason = learningReasons.find(item => item.id === parseInt(languageProfile.selectedReasonId));
    if (selectedReason && selectedReason.description === "Other") {
      return (<div className="input-group mx-auto mt-4">
        <OtherReason
          handleChange={this.handleChange}
          otherReason={languageProfile.otherReason}
        />
      </div>)
    }
  }

  render() {
    const { language, languageProfile, onBack } = this.props;
    const { learningReasonFetching, learningReasonFetchError, learningReasons, submitting, submitError } = this.state;

    if (learningReasonFetching) {
      return (<Loading className="btn-next" size="medium" />);
    }

    if (learningReasonFetchError) {
      return (<React.Fragment>
        <p className="text-danger my-2">{learningReasonFetchError}</p>
        <Footer onBack={onBack} />
      </React.Fragment>);
    }

    return (
      <form onSubmit={this.handleNext}>
        <div className="mx-auto onboard-step onboard-step--2 onboard-step--language-profile">
          <p className="step__number" data-qa-id="step2-title">Step 2/3</p>
          <h4 className="mb-2">Let's get to know each other</h4>
          <div className="mb-4">
            <small style={{color: '#aaa'}}>We'll share this with your Rype language teachers.</small>
          </div>
          <p className="mb-2">
            <span style={{ color: 'red' }}>*</span> Which best describes your level of {this.props.language}?
          </p>
          <div className="input-group mx-auto">
            <LevelSelect
              handleChange={this.handleChange}
              level={languageProfile.level}
            />
          </div>
          <p className="mb-2 mt-4">
            <span style={{ color: 'red' }}>*</span> Why are you learning {language}?
          </p>
          <div className="input-group mx-auto">
            <LearningReasonSelect
              handleChange={this.handleChange}
              learningReasons={learningReasons}
              learningReasonId={languageProfile.selectedReasonId}
            />
          </div>
          {this.renderOtherReasonInput()}
          <div className="mb-2 mt-4">Share a bit more about your language learning journey!</div>
          <div className="input-group mx-auto">
            <AdditionalInfo
              handleChange={this.handleChange}
              additionalInfo={languageProfile.additionalInfo}
            />
          </div>
          <div className="bginfo__char-count">{languageProfile.additionalInfo.length} / 1000</div>
          {submitError && <p className="text-danger my-2">{submitError}</p>}
          {submitting ? (
            <Loading className="btn-next" size="small" />
          ) : (
              <button
                type="submit"
                className="btn btn-primary btn-lg btn-cursor btn-next my-3 px-5"
                disabled={submitting}
              >
                Next
              </button>
            )}
        </div>
        <Footer
          onBack={onBack}
          isLoading={submitting}
        />
      </form>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.profile
  };
}

export default connect(mapStateToProps)(LanguageProfile);



// WEBPACK FOOTER //
// ./src/pages/student/OnBoard/LanguageProfile/index.js